
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/verify-email/success",
      function () {
        return require("private-next-pages/auth/verify-email/success.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/verify-email/success"])
      });
    }
  